'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import styles from '@/styles/dashboard.module.css';
import { HomeIcon, VideoIcon, FileIcon } from './Icons';

const navItems = [
  { href: '/meetings', icon: VideoIcon, label: 'Meetings' },
  { href: '/home', icon: HomeIcon, label: 'Home' },
  { href: '/recordings', icon: FileIcon, label: 'Recordings' },
];

export function Sidebar() {
  const pathname = usePathname();

  return (
    <aside className={styles.sidebar}>
      <div className={styles.sidebarTop}>
        {navItems.map(({ href, icon: Icon, label }) => {
          const active = pathname === href || pathname?.startsWith(`${href}/`);
          return (
            <Link key={href} href={href} className={`${styles.sidebarItem} ${active ? styles.sidebarItemActive : ''}`}>
              <Icon size={24} color="currentColor" />
              <span className={styles.sidebarLabel}>{label}</span>
            </Link>
          );
        })}
      </div>

      <div className={styles.sidebarBottom} />
    </aside>
  );
}
